import { render } from "./About.vue?vue&type=template&id=71033bd3&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=71033bd3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71033bd3"

export default script